import React, { useState, useEffect } from "react";
import gql from "graphql-tag";
import { useApolloClient } from "@apollo/react-hooks";
import { Accordion } from "react-bootstrap";
import MachineDetails from "./components/MachineDetails";
import MachineManufacturing from "./components/MachineManufacturing";
import PowderMfg from "./components/PowderMfg";
import MaterialProcessing from "./components/MaterialProcessing";
import AmProcess from "./components/AmProcess";
import Transportation from "./components/Transportation";
import PostProcessing from "./components/PostProcessing";
import WastePowder from "./components/WastePowder";
 
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  technologyId,
  stepTypeId,
  technologyType,
} from "atoms/General/index.js";
 

import { ProcessFlag } from "atoms/General/index.js";
import { useRecoilState, useRecoilValue } from "recoil";
const Process = ({ ScenarioState, socket }) => {
  const GET_CLIENT_STEPS = gql`
    query ($technology_id: Int, $type_id: Int) {
      getClientSteps(technology_id: $technology_id, type_id: $type_id) {
        step_id
        name
        description
        selected_icon
        unselected_icon
        is_blocked
        step_type_id {
          step_type_id
          name
          description
          is_blocked
          is_premium
        }
        technology_id {
          technology_id
          name
        }
      }
    }
  `;
  const client = useApolloClient();
  const [clientSteps, setClientSteps] = useState([]);
  const [loader, setLoader] = useState(true);
  const [, setTechId] = useRecoilState(technologyId);
  const [, setStepTypeId] = useRecoilState(stepTypeId);
  const [, settechnologyType] = useRecoilState(technologyType);
  const processFlag = useRecoilValue(ProcessFlag);
  useEffect(() => {
    setTechId(2);
    setStepTypeId(3);
    settechnologyType("CO2e Polymer");
    client
      .query({
        query: GET_CLIENT_STEPS,
        variables: { technology_id: 2, type_id: 3 },
      })
      .then(({ data, loading }) => {
        setClientSteps(data.getClientSteps);
        // console.log(data.getClientSteps);
        setLoader(false);
      })
      .catch((error) => {
        console.log("error in process", error);
        // toast.error(error.graphQLErrors[0].messasge.message)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


 


  return (
    <>
      {loader ? (
        <div className="d-flex justify-content-center align-items-center pt-5">
          <Spinner animation="border" />{" "}
        </div>
      ) : (
        <>
          {" "}
          <Accordion>
            {clientSteps &&
              clientSteps.map((step, index) => {

                return (
                  <div className="mb-40">
                    {step?.step_id === 59 && (
                      <>
                        <div className="table-title-border mb-24">
                          <span className="font-24 font-semi-bold">Machine Details </span>
                        </div>
                        <div className="d-flex flex-wrap gap-20 ">
                          <MachineDetails StepID={59} Socket={socket} />
                        </div>
                      </>
                    )}
                    {step?.step_id === 60 &&
                      (processFlag.MachineManufacturing && (
                        <MachineManufacturing StepID={60} />
                      ) )}
                    {step?.step_id === 61 &&
                      processFlag.MachineDetails && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">Powder Manufacturing </span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <PowderMfg Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 62 &&
                      processFlag.PowderManufacturing && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">Material Processing </span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <MaterialProcessing Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 63 &&
                      processFlag.MaterialProcessing && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">Additive Manufacturing Process</span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <AmProcess Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 64 &&
                      processFlag.AMProcess && (
                        <>
                          <div className="table-title-border mb-24">
                            <span className="font-24 font-semi-bold">Logistics </span>
                          </div>
                          <div className="d-flex flex-wrap gap-20 ">
                            <Transportation Socket={socket} />
                          </div>
                        </>
                      )}
                    {step?.step_id === 65 &&
                      processFlag.PostProcessing && <PostProcessing />}
                    {step?.step_id === 66 &&
                      processFlag.WastePowder && <WastePowder />}
                    {/* {step?.step_id === 67 &&
                                            (activeState === index &&
                                                <Co2Process Socket={socket} />)
                                        } */}
                  </div>
                );
              })}
          </Accordion>
          <div style={{ width: "inherit" }}>
            <div className="d-flex justify-content-center pt-1 w-75 flex-column">
              <p className="f-14 mb-24">
                Please note that the EOS Cost and Carbon Calculator provides
                only rough estimates. EOS assumes no liability for the
                information from this tool. For precise and reliable values,
                please consult with Additive Minds at EOS. Please see the Data
                Matrix to understand the basis for the calculation of the EOS
                Cost & Carbon Calculator.
              </p>
            </div>
          </div>
          {/* <button
            onClick={() => {
              if (processFlag.Transportation) {
                ScenarioState();
              } else {
                toast.error("Please fill all process details.");
              }
            }}
            className="selection-button step-button"
          >
            Proceed
          </button> */}
        </>
      )}
    </>
  );
};

export default Process;
